export default "__VITE_ASSET__002f212e__"